<div class="step-panel step-panel-compact step-panel-presupuesto">
  <h3>Presupuesto</h3>
  <p class="step-intro">Ingresa los montos por categor&iacute;a para detallar el presupuesto solicitado del proyecto.</p>

  <ng-container *ngIf="presupuestosPorInstitucion.length > 0; else sinInstitucionesPresupuesto">
    <div class="section-block">
      <h4>Presupuesto por instituci&oacute;n</h4>

      <div class="records-list">
        <div
          class="record-card budget-institution-card"
          *ngFor="let presupuesto of presupuestosPorInstitucion; let presupuestoIndex = index; trackBy: trackByPresupuesto"
        >
          <div class="record-top">
            <div class="budget-institution-title">
              <h4>{{ presupuesto.nombreInstitucion }}</h4>
              <p>
                <span>{{ etiquetaTipoInstitucion(presupuesto.rolInstitucion) }}</span>
                <span *ngIf="presupuesto.unidadInstitucional">Unidad: {{ presupuesto.unidadInstitucional }}</span>
                <span *ngIf="presupuesto.departamentoFacultad">Departamento / Facultad: {{ presupuesto.departamentoFacultad }}</span>
              </p>
            </div>

            <div class="record-actions">
              <span class="status-pill" [ngClass]="presupuesto.rolInstitucion === 'principal' ? 'status-ok' : 'status-pending'">
                {{ etiquetaTipoInstitucion(presupuesto.rolInstitucion) }}
              </span>
              <strong>Total instituci&oacute;n: {{ totalInstitucion(presupuesto) | number:'1.0-0' }}</strong>
            </div>
          </div>

          <div class="record-actions budget-institution-actions">
            <button
              type="button"
              class="btn-secondary btn-small"
              [attr.aria-expanded]="estaResumenAbierto(presupuesto, presupuestoIndex)"
              (click)="alternarResumen(presupuesto, presupuestoIndex)"
            >
              {{ estaResumenAbierto(presupuesto, presupuestoIndex) ? 'Ocultar resumen' : 'Ver resumen' }}
            </button>
            <button type="button" class="btn-primary btn-small" (click)="abrirDetallePresupuesto(presupuesto)">
              Ver detalle presupuesto
            </button>
          </div>

          <div class="budget-summary-panel" *ngIf="estaResumenAbierto(presupuesto, presupuestoIndex)">
            <table class="budget-summary-table">
              <thead>
                <tr>
                  <th>&Iacute;tem</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of presupuesto.items; trackBy: trackByItem">
                  <td>{{ item.item }}</td>
                  <td>{{ totalItem(item) | number:'1.0-0' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #sinInstitucionesPresupuesto>
    <div class="section-block">
      <h4>Recursos del proyecto</h4>
      <div class="placeholder-box budget-empty-message">
        Primero registra al menos una instituci&oacute;n en el paso Instituciones para habilitar el presupuesto asociado.
      </div>
    </div>
  </ng-template>

  <div class="budget-modal-backdrop" *ngIf="presupuestoDetalleActivo as presupuestoDetalle" (click)="cerrarDetallePresupuesto()">
    <section
      class="budget-modal budget-detail-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="presupuesto-modal-title"
      (click)="$event.stopPropagation()"
    >
      <header class="budget-detail-header">
        <div class="budget-detail-title">
          <h4 id="presupuesto-modal-title">Detalle presupuesto - {{ presupuestoDetalle.nombreInstitucion }}</h4>
          <p>
            {{ etiquetaTipoInstitucion(presupuestoDetalle.rolInstitucion) }}
            <span *ngIf="presupuestoDetalle.unidadInstitucional"> &middot; Unidad: {{ presupuestoDetalle.unidadInstitucional }}</span>
            <span *ngIf="presupuestoDetalle.departamentoFacultad">
              &middot; Departamento / Facultad: {{ presupuestoDetalle.departamentoFacultad }}
            </span>
          </p>
        </div>
        <button type="button" class="btn-secondary btn-small budget-close-button" (click)="cerrarDetallePresupuesto()">
          Cerrar
        </button>
      </header>

      <div class="budget-detail-panel">
        <h4>Recursos solicitados por instituci&oacute;n</h4>
        <p>
          Ingresa los montos por &iacute;tem, sub&iacute;tem y a&ntilde;o para {{ presupuestoDetalle.nombreInstitucion }}.
        </p>

        <div class="budget-detail-items">
          <div class="budget-item-card" *ngFor="let item of presupuestoDetalle.items; trackBy: trackByItem">
            <h4 class="budget-item-head">
              <span>{{ item.item }}</span>
              <span class="budget-item-actions">
                <button
                  type="button"
                  class="btn-secondary btn-small budget-add-line"
                  *ngIf="esItemEquipamiento(item) && !soloLectura"
                  (click)="agregarLineaEquipamiento(item)"
                >
                  + Agregar equipamiento
                </button>
                <span>Subtotal: {{ totalItem(item) | number:'1.0-0' }}</span>
              </span>
            </h4>

            <div class="budget-table-wrap">
              <table class="budget-table budget-detail-table">
                <thead>
                  <tr>
                    <th>Sub&iacute;tem</th>
                    <th *ngFor="let anio of aniosPresupuesto">A&ntilde;o {{ anio }}</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let subitem of item.subitems; let subitemIndex = index; trackBy: trackBySubitem">
                    <td>
                      <div *ngIf="esItemEquipamiento(item); else subitemFijo" class="budget-subitem-edit">
                        <input
                          type="text"
                          class="budget-subitem-name-input"
                          [ngModel]="subitem.nombre"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="actualizarNombreSubitem(subitem, $event)"
                          [disabled]="soloLectura"
                          placeholder="Ej: Notebook"
                        />
                        <button
                          type="button"
                          class="btn-secondary btn-small budget-remove-line budget-remove-icon"
                          *ngIf="puedeEliminarLineaEquipamiento(item, subitemIndex)"
                          (click)="eliminarLineaEquipamiento(item, subitemIndex)"
                          aria-label="Eliminar equipamiento"
                          title="Eliminar equipamiento"
                        >
                          <svg aria-hidden="true" viewBox="0 0 24 24" focusable="false">
                            <path d="M9 3h6l1 2h4v2H4V5h4l1-2Z" />
                            <path d="M6 9h12l-1 12H7L6 9Zm4 2v8h2v-8h-2Zm4 0v8h2v-8h-2Z" />
                          </svg>
                        </button>
                      </div>
                      <ng-template #subitemFijo>{{ etiquetaSubitem(item, subitem) }}</ng-template>
                    </td>
                    <td *ngFor="let anio of aniosPresupuesto; let anioIndex = index">
                      <input
                        type="number"
                        min="0"
                        [ngModel]="montoSubitem(subitem, anioIndex)"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="actualizarMontoSubitem(subitem, anioIndex, $event)"
                        [disabled]="soloLectura"
                      />
                    </td>
                    <td class="budget-total-cell">{{ totalSubitem(subitem) | number:'1.0-0' }}</td>
                  </tr>
                  <tr class="budget-subtotal-row">
                    <td>Subtotal {{ item.item }}</td>
                    <td [attr.colspan]="aniosPresupuesto.length"></td>
                    <td>{{ totalItem(item) | number:'1.0-0' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <label class="field budget-institution-total">
          <span>Total instituci&oacute;n</span>
          <input type="text" [value]="totalInstitucion(presupuestoDetalle) | number:'1.0-0'" disabled />
        </label>

        <p class="budget-save-feedback" *ngIf="mensajeGuardado">{{ mensajeGuardado }}</p>
      </div>

      <footer class="budget-detail-footer">
        <button
          type="button"
          class="btn-primary btn-small"
          *ngIf="!soloLectura"
          (click)="solicitarGuardadoPresupuesto()"
          [disabled]="guardando"
        >
          {{ guardando ? 'Guardando...' : 'Guardar presupuesto' }}
        </button>
        <button type="button" class="btn-secondary btn-small budget-close-button" (click)="cerrarDetallePresupuesto()">
          Cerrar
        </button>
      </footer>
    </section>
  </div>
</div>
